import styled from 'styled-components';

import { Frame, Link, RowWrapper } from 'components/StyledTemplates/StyledTemplates';
import WistiaPlayer from 'components/StyledTemplates/WistiaPlayer';

import ModalsService from 'services/ModalsService';

import useResources from 'hooks/useResources';

import imgVideoPlayButton from 'assets/video-play-button.svg';

interface LearnCenterProps {
    withHeader?: boolean;
    resourcesPath?: string;
    articles: any[];
}

const LearnCenter = (props: LearnCenterProps) => {
    const { withHeader = true, resourcesPath = 'newDashboardPage.learnCenter', articles = [] } = props;

    const { t } = useResources();

    const handlers = {
        openVideoPlayer: (video_id: string) => () => {
            ModalsService.showModality(
                '',
                <WistiaPlayer video_id={video_id} style={{ width: '100%', height: '455px' }} />,
                {
                    displayCloseButton: false,
                    displayConfirmButton: false,
                    displayCloseCross: false,
                    extra: 'background: #CECDD0;',
                    className: 'shadow',
                },
            );
        },
    };

    return (
        <>
            {withHeader && (
                <h4 className="serif mt-5 text-dark w-full d-flex justify-content-between mb-4">
                    {t(`${resourcesPath}.header`)}
                    <VisitLink absolute={true} to="https://www.myadvocate.com/learn">
                        {t(`${resourcesPath}.visitLink`)}
                    </VisitLink>
                </h4>
            )}
            <LearnCenterArticles>
                {(!Array.isArray(articles) || articles.length === 0) && <i>Resources list is empty</i>}
                {Array.isArray(articles) &&
                    articles.map((a: any, index: number) => {
                        if (a.type === 'Video') {
                            return (
                                <LearnCenterArticle key={index} onClick={handlers.openVideoPlayer(a.wistiaId)}>
                                    <LearnCenterArticleImage className="videoThumbnail">
                                        <img src={a.url} alt="video" style={{ maxWidth: '100%', height: 'auto' }} />
                                    </LearnCenterArticleImage>
                                    <LearnCenterArticleHeader>{a.header}</LearnCenterArticleHeader>
                                    <LearnCenterArticleDescription>{a.description}</LearnCenterArticleDescription>
                                    <LearnCenterArticleType>{a.type}</LearnCenterArticleType>
                                </LearnCenterArticle>
                            );
                        }
                        return (
                            <Link key={index} absolute={true} to={a.link} target={a.target || '_self'}>
                                <LearnCenterArticle>
                                    <LearnCenterArticleImage>
                                        <img src={a.image} alt="article" />
                                    </LearnCenterArticleImage>
                                    <LearnCenterArticleHeader>{a.header}</LearnCenterArticleHeader>
                                    <LearnCenterArticleDescription>{a.description}</LearnCenterArticleDescription>
                                    <LearnCenterArticleType>{a.type}</LearnCenterArticleType>
                                </LearnCenterArticle>
                            </Link>
                        );
                    })}
            </LearnCenterArticles>
        </>
    );
};

const VisitLink = styled(Link)`
    font-weight: 600;
    font-size: 16px;
    line-height: 30px;
    text-align: right;
    text-decoration-line: underline;
    color: #3c5d30;
`;

const LearnCenterArticles = styled(Frame)`
    border: 1px solid #dfdfdf;
    border-radius: 8px;
    padding: 55px 34px;
    flex-direction: row;
    gap: 37px;
    align-items: flex-start;
    background: #fff;
    width: 100%;
    justify-content: flex-start;

    > * {
        display: flex;
        flex: 1;
        width: 100%;
        max-width: 33%;
        gap: 4px;
    }

    .videoThumbnail {
        position: relative;
        cursor: pointer;

        &:after {
            content: '';
            width: 90px;
            height: 90px;
            background: url('${imgVideoPlayButton}') no-repeat center center / contain;
            border-radius: 9999px;
            position: absolute;
            transition: 0.2s;
        }
        &:hover {
            &:after {
                transform: scale(1.05);
            }
        }
    }

    @media (max-width: 768px) {
        flex-direction: column;
        justify-content: center;
        align-items: center;

        > * {
            max-width: unset;
        }
    }
`;

const LearnCenterArticle = styled(Frame)``;

const LearnCenterArticleImage = styled(Frame)`
    width: 100%;
    height: 154px;

    img {
        object-fit: cover;
        width: 100%;
        height: 100%;
    }
`;

const LearnCenterArticleHeader = styled(RowWrapper)`
    /*font-family: 'Marcellus';*/
    font-size: 17.6646px;
    line-height: 24px;
    color: #201f22;
    margin-bottom: 8px;
    margin-top: 20px;
`;

const LearnCenterArticleDescription = styled(RowWrapper)`
    font-size: 13.6499px;
    line-height: 21px;
    color: #201f22;
    margin-bottom: 8px;
`;

const LearnCenterArticleType = styled(RowWrapper)`
    font-size: 11.2411px;
    line-height: 16px;
    color: #77767a;
`;

export default LearnCenter;
